"use strict";
function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;
//# sourceMappingURL=_stackGet.js.map